<div class="grid-container">
  <div class="grid-row">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <legend class="usa-legend usa-legend--medium">HHG Shipment Summary Report</legend>
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-y-4">
      <span>
          This report contains the summary of all Booked/Completed shipments .
      </span>
    </div>
    <form id="filterGroup" [formGroup]="filterGroup">
      <div class="grid-row grid-gap">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="hhg_search_by_date_from" class="usa-label">From: </label>
          <input type="text" id="hhg_search_by_date_from" class="usa-input maxw-full"
                 placeholder="mm/dd/yyyy" bsDatepicker formControlName="fromDate" (bsValueChange)="filterFromDateChange($event)"
                 [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY', containerClass: 'theme-dark-blue', showWeekNumbers: false }">
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="hhg_search_by_date_to" class="usa-label">To: </label>
          <input type="text" id="hhg_search_by_date_to" class="usa-input maxw-full"
                 placeholder="mm/dd/yyyy" bsDatepicker formControlName="toDate" (bsValueChange)="filterToDateChange($event)"
                 [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY', containerClass: 'theme-dark-blue', showWeekNumbers: false }">
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label  class="usa-label">&nbsp;  </label>
          <button type="button" class="usa-button" (click)="seatchByFilter()"> Search </button>
        </div>
      </div>
    </form>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-y-4">
      <span>
        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
          <use xlink:href="/assets/uswds/img/sprite.svg#file_download"></use>
        </svg>
        Right click on the report and select the appropriate options to export.
      </span>
    </div>
           <!-- <p>May need to improve searching</p> -->
              <!-- <form id="filterGroup" role="form" [formGroup]="filterGroup">
                <div class="row">
                  <div class="col-md-4">
                    <label for="from_date">From: </label>
                    <input type="text" id="hhg_search_by_date_from" class="w-100"
                      placeholder="mm/dd/yyyy" bsDatepicker formControlName="fromDate" (bsValueChange)="filterFromDateChange($event)"
                      [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY', containerClass: 'theme-dark-blue', showWeekNumbers: false }">
                  </div>
                  <div class="col-md-4">
                    <label for="to_date">To: </label>
                    <input type="text" id="hhg_search_by_date_to" class="w-100"
                      placeholder="mm/dd/yyyy" bsDatepicker formControlName="toDate" (bsValueChange)="filterToDateChange($event)"
                      [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY', containerClass: 'theme-dark-blue', showWeekNumbers: false }">
                  </div>
                  <div class="col-md-2">
                      <button type="button" class="btn btn-primary" (click)="seatchByFilter()"> Search </button>
                  </div>
              </div>
              </form> -->
              <!--<div class="row mb-3">
                <div class="col text-right">
                  <button type="button" class="btn btn-outline-secondary btn-sm py-2 w-auto" (click)='generateDownload()'><i class="fa fa-download"></i> Export</button>
                </div>
              </div>-->
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <ag-grid-angular class="ag-theme-alpine"
                  style="height: 400px;"
                  [rowData]="hhgListDetails"
                  [domLayout]="domLayout"
                  [pagination]="true"
                  [excelStyles]="excelStyles"
                  [paginationPageSize]="paginationPageSize"
                  [columnDefs]="hhgListColumnDefs"
                  (gridReady)="onGridReady($event)">
                </ag-grid-angular>
    </div>
  </div>
</div>
